import { FC } from "react"
import { Navigate, Outlet } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"
import { useUserInfo } from "~/store/user/userSlice"

const ProtectedRoutes: FC = () => {
  const { isLogin, user } = useUserInfo()
  // const token = getCookie("token")
  // const token = localStorage.getItem("adminToken");
  const { token } = user
  return isLogin && token ? (
    <Outlet />
  ) : (
    <Navigate replace to={APP_ROUTES.login} />
  )
  // return <Outlet />
}
export default ProtectedRoutes
